<template>
  <div class="forbidden">
    <div class="card">
      <div class="icon"><v-icon size="30" color="#66c7b4">mdi-shield-alert-outline</v-icon></div>

      <h1 class="code">403</h1>
      <h2 class="title">Access denied</h2>

      <p class="message">
        You don't have permission to access this page.
        Contact your administrator if you believe this is a mistake.
      </p>

      <button class="duallo-btn duallo-btn--primary back-btn" @click="goBack">
        Go back
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ForbiddenPage",
  methods: {
    goBack() {
      this.$router.push({ name: 'Assets' });
    },
  },
};
</script>

<style scoped>
.forbidden {
  min-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: radial-gradient(120% 80% at 50% 0%, #20272e 0%, #141a1f 60%);
  color: var(--duallo-text-primary);
}

.card {
  max-width: 420px;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  background: var(--duallo-card-gradient);
  border: 1px solid var(--duallo-border-strong);
  border-radius: var(--duallo-radius-xl);
  box-shadow: var(--duallo-shadow-lg);
  padding: 28px 24px 24px;
}

.icon {
  width: 56px;
  height: 56px;
  border-radius: var(--duallo-radius-xl);
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(102, 199, 180, 0.1);
  border: 1px solid var(--duallo-border-accent);
}

.code {
  font-size: 4rem;
  margin: 4px 0 0;
  font-weight: 800;
  letter-spacing: -2px;
  color: var(--duallo-text-primary);
  line-height: 1;
}

.title {
  font-size: 1.25rem;
  margin: 0;
  font-weight: 800;
  color: var(--duallo-text-primary);
}

.message {
  color: var(--duallo-text-muted);
  font-size: 0.92rem;
  line-height: 1.55;
  margin: 0;
}

.back-btn {
  margin-top: 8px;
}
</style>
